import {
  Box,
  Button,
  Chip,
  Grid2,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { Quiz as QuizIcon } from "@mui/icons-material";

const HomeSection = ({
  isCompact,
  onSelectView,
  quizCount,
  loading,
}) => {
  const quizLabel = loading ? "Loading..." : `${quizCount} quiz sets`;

  return (
    <Grid2 container spacing={3} alignItems="center">
      <Grid2 size={{ xs: 12, md: 7 }}>
        <Stack spacing={2}>
          <Chip
            icon={<QuizIcon />}
            label="Quizzes"
            color="secondary"
            sx={{ width: "fit-content" }}
          />
          <Typography variant={isCompact ? "h3" : "h2"}>
            Learning for everyone
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Select a subject, then practice with randomized quizzes. Everything
            is organized to help you learn effectively.
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
            <Button
              variant="contained"
              size="large"
              onClick={() => onSelectView("quizzes")}
            >
              Go to quizzes
            </Button>
          </Stack>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            sx={{ mt: 1 }}
          >
            <Chip
              label="Grade 1-8"
              size="small"
              sx={{
                bgcolor: "action.selected",
                cursor: "default",
                "&:hover": { bgcolor: "action.selected" },
              }}
            />
            <Chip
              label={quizLabel}
              size="small"
              sx={{
                bgcolor: "action.selected",
                cursor: "default",
                "&:hover": { bgcolor: "action.selected" },
              }}
            />
          </Stack>
        </Stack>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 5 }}>
        <Paper elevation={0} sx={{ p: 3, bgcolor: "background.paper" }}>
          <Stack spacing={2}>
            <Typography variant="h5">Study playlist</Typography>
            <Typography variant="body2" color="text.secondary">
              Choose a subject, then explore randomized quizzes at your own
              pace. Small steps lead to mastery.
            </Typography>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1} flexWrap="wrap">
              <Chip icon={<QuizIcon />} label="Quizzes" />
              <Chip label="Daily practice" />
            </Stack>
            <Box>
              <Typography variant="caption" color="text.secondary">
                Tip: Use the subject dropdown in the navbar to switch
                subjects quickly.
              </Typography>
            </Box>
          </Stack>
        </Paper>
      </Grid2>
    </Grid2>
  );
};

export default HomeSection;
